import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ROUTES } from '@shared/constants/routes';
import { AuthService } from '@shared/services/auth.service';
import { isPlatformBrowser } from '@angular/common';


export const AuthGuard: CanActivateFn = () => {
  const platformId = inject(PLATFORM_ID);
  const authService = inject(AuthService);
  const router = inject(Router);

  // 🚫 Durante SSR non deve bloccare routing
  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  // ✔️ Solo nel browser controlli lo user
  if (!authService.isLoggedIn()) {
    router.navigate(['/']);
    return false;
  }

  return true;
};
